/* @jsxImportSource @emotion/react */

import { colors } from 'app/common/arctechv2/theme';
import { css } from '@emotion/react';

export const scCss = css`
    display: flex;
    height: 100vh;
    overflow: hidden;
`;

export const pageMainCss = css`
    flex: 1 1 auto;
    overflow-y: auto;
`;

export const iframeCss = css`
    width: 100%;
    height: 100%;
    // z-index: 5;
    display: flex;
    flex-direction: column;
    overflow-x: scroll;

    .pages {
        display: flex;
        height: 100%;
    }
`;

export const publicCss = css`
		width: 100%;
		height: 100%;
		// z-index: 5;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		// flex-basis: calc(100vw - 280px);

		// .is-closed + && {
		// 	flex-basis: 100vw;
		// }

		.pages {
			display: flex;
			height: 100%;
		}

		@-webkit-keyframes fadeIn {
			from {
			  opacity: 0;
			}
		  
			to {
			  opacity: 1;
			}
		  }
		  @keyframes fadeIn {
			from {
			  opacity: 0;
			}
		  
			to {
			  opacity: 1;
			}
		  }
		  
		  /*--keyframe pointer --*/
		  .fadeIn { 
			animation-name: fadeIn;
		  }
		

		.modal-close{
			display: none;
		}

		.modal {

			> div:not(:first-of-type):last-of-type:not(:empty) {
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				overflow-x: hidden;
				overflow-y: auto;
				outline: 0;
				background: rgba(0, 0, 0, 0.25);

				&:not(:has(.modal-v2-sliding)) {
					transition: background 250ms ease-in-out;
				}

				&:has(> div:not(:empty)) {
					z-index: 1060;
				}

				&:has(.modal-v2) {
					display: flex;
					justify-content: center;
					align-items: center;

					.modal-v2 {
						right: 5%;
					}
				}


				.modal-close {
					display: block;
					position: absolute;
					top: 0;
					right: 0;
					padding: 10px;
					
					i {
						font-size: 2.5rem;
						color: black;
					}
				}


				> div:not(:empty) {
					position: absolute;

					right: 0;
					height: 95vh;
					overflow: auto;

					animation-duration: .5s;
					animation-fill-mode: both;
					animation-delay: 0.1s;
					border-radius: .475rem;
			
					width: 90%;
					max-width: 90%;
					
					
					background: #fff;
					padding: 30px;

					&.modal-v2 {
						padding: 15px;
						border-radius: 20px;
					}

					&.modal-v2-sliding {
						max-width: 1000px;
						margin: 0;
						height: 100vh;
						border-radius: 0;
						box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);

						animation-duration: 100ms;
						animation-fill-mode: both, forwards, none;
						animation-name: slidingModal;
						animation-timing-function: linear;
						background: ${colors.gray050};

					}
				}

				> div.site-nav {
					margin-left: 320px;
				}
			}

		}	


		.modal.site-nav {
			> div:not(:first-of-type):last-of-type:not(:empty) > div {
					max-width: 80%;
					width: 80% !important;
					margin-left: 320px;
			}
		}

		/**
		@media only screen and (max-width: 1900px) {
			.pages {

				> div:first-of-type:nth-last-of-type(2),
				> div:first-of-type:nth-last-of-type(2) ~ div {
					&:first-of-type {
						display: none;
					}
					
					&:last-of-type {
						position: absolute;
						/* margin-left: 90px;
						margin-right: 20px;
						*/
/**						width: 90vw;
						max-width: 90vw; **/
						background-color: #f5f8fa;
					}
	
				}

			}
		}
		**/

		@media only screen and (min-width: 1901px) {
			.pages {

				.split {	
					max-width: 45vw;
				}
			}
		}

		.pages:only-child {
		}
	`;
